import {
  Component,
  OnInit,
  OnDestroy,
  ViewContainerRef,
  AfterViewInit,
} from "@angular/core";
import { ToastrManager } from "ng6-toastr-notifications";
import { Subscription } from "rxjs/Subscription";
import { MessageModel } from "./messageService.model";
import { MessageService } from "./messageService.service";

@Component({
  selector: "app-message",
  templateUrl: "messageService.component.html",
  styleUrls: ["messageService.component.css"],
})
export class MessageSericeComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private subscription: Subscription;
  messageDetail: MessageModel = new MessageModel();

  constructor(
    public messageService: MessageService,
    public toastr: ToastrManager
  ) {}

  ngOnInit() {
    this.subscription = this.messageService.loaderState.subscribe(
      (state: MessageModel) => {
        this.messageDetail = state;
        this.messageDetail.showCloseButton = true;
        this.toastr.successToastr(this.messageDetail.body);
      }
    );
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
